const scriptStyle = {
  fontSize: "75%",
  lineHeight: 0
}

export {scriptStyle}
